import { HR } from 'foundations-components/transitional/components/HR';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import TaskGroupCheckbox from './TaskGroupCheckbox';
import TaskGroupProgress from './TaskGroupProgress';
import { useTaskDataByGroupKey } from '../../../hooks/task';
import { useTracker } from '../../../hooks/tracking';
import AssignedTaskNotification from './AssignedTaskNotification';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TaskGroup = ({
  isLastGroup,
  isTaskGroupCompleted,
  groupKey,
  onGroupClick
}) => {
  const taskGroupData = useTaskDataByGroupKey(groupKey);
  const {
    name: groupTitle,
    description: groupSubtitle
  } = taskGroupData;
  const {
    trackUserInteraction
  } = useTracker();
  return /*#__PURE__*/_jsxs(Flex, {
    "data-group-locator": groupKey,
    flexDirection: "column",
    children: [/*#__PURE__*/_jsxs(Flex, {
      columnGap: "200",
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(TaskGroupCheckbox, {
          isChecked: isTaskGroupCompleted
        })
      }), /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        flexGrow: "1",
        children: /*#__PURE__*/_jsx(AssignedTaskNotification, {
          viewGroupKey: groupKey,
          children: /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h5",
              marginBlockEnd: "0",
              children: /*#__PURE__*/_jsx(Link, {
                "data-test-id": `task-group-link-${groupKey}`,
                onClick: () => {
                  if (onGroupClick) {
                    onGroupClick(groupKey);
                  }
                  trackUserInteraction('card task group click', groupKey);
                },
                children: groupTitle
              })
            }), groupSubtitle && /*#__PURE__*/_jsx(Text, {
              marginBlockEnd: "0",
              marginBlockStart: "100",
              children: groupSubtitle
            })]
          })
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(TaskGroupProgress, {
          groupKey: groupKey,
          isTaskGroupCompleted: isTaskGroupCompleted,
          onGroupClick: onGroupClick
        })
      })]
    }), !isLastGroup && /*#__PURE__*/_jsx(View, {
      marginBlock: "500",
      paddingInlineStart: "1000",
      children: /*#__PURE__*/_jsx(HR, {
        color: "border-core-subtle",
        margin: "0"
      })
    })]
  });
};
export default TaskGroup;